import { Link } from 'gatsby';
import { HOME_PAGE } from '../../../../constants/page-links';
import DuxLogo from '../../../../images/duxiana-logo.inline.svg';
/**
 * @description Render memoized logo header component
 * @param {Object} props
 * @returns {JSX.Element} Memoized logo header component
 */
export const LogoHeader = (props) => {
  const { onClick } = props;
  return (
    <div className="header__logo">
      <Link to={HOME_PAGE} onClick={onClick}>
        <DuxLogo title="Main Logo" />
      </Link>
    </div>
  );
};
